import { render } from "./Buttons.vue?vue&type=template&id=7d315f50&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import "./Buttons.vue?vue&type=style&index=0&id=7d315f50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d315f50"

export default script